export const PRIVACY_STATEMENT_ROUTE = '/lp/legal/privacy/'
export const TERMS_OF_USE_ROUTE = '/lp/legal/terms/'
